// extracted by mini-css-extract-plugin
export default {"button":"app-date-range-selector_button__OqYXO","selected":"app-date-range-selector_selected__PO7BM"};